import {} from '@mantine/core';
import React from 'react';
import { CopyableTextInput } from '../inputs/CopyableTextInput';

interface IdDisplayProps {
    value: string;
    label?: string;
    disabled?: boolean;
}

export const IdDisplay: React.FC<IdDisplayProps> = ({ value, label = undefined, disabled }) => {
    return <CopyableTextInput disabled={disabled} label={label} value={value} size="xs" readOnly />;
};
